import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import {
  errorMessage, fetchCatalogItems, fetchCatalogs, fetchMappings, fetchProducts, mapProduct, syncAvailability, unmapProduct,
} from "../api";

/** Vínculo produto do Núcleo ↔ item do cardápio no iFood. */
export default function useIfoodCatalog() {
  const [state, setState] = useState({ catalogs: [], mappings: [], products: [], ifoodItems: [] });
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState("");

  // `loading` só na 1ª leitura: recarregar depois de casar códigos não pisca a aba (25/10/2026).
  const reload = useCallback(async () => {
    try {
      const [catalogs, mappings, products] = await Promise.all([
        fetchCatalogs().catch(() => []), fetchMappings().catch(() => []), fetchProducts().catch(() => []),
      ]);
      setState((s) => ({ ...s, catalogs, mappings, products: products.filter((p) => !p.is_insumo && p.sale_price > 0) }));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const loadIfoodItems = async () => {
    setBusy("items");
    try {
      const ifoodItems = await fetchCatalogItems();
      setState((s) => ({ ...s, ifoodItems }));
      toast.success(`${ifoodItems.length} itens no cardápio do iFood`);
      return ifoodItems;
    } catch (e) {
      toast.error(errorMessage(e, "Não foi possível ler o cardápio do iFood"));
      return [];
    } finally {
      setBusy("");
    }
  };

  const map = async (product, item) => {
    try {
      await mapProduct(product.id, {
        ifood_catalog_id: item._catalog_id, ifood_item_id: item.id || item.itemId,
        ifood_item_name: item.name || item.itemName || "", auto_sync: true,
      });
      toast.success(`"${product.name}" vinculado a "${item.name || item.itemName}"`);
      reload();
      return true;
    } catch (e) {
      toast.error(errorMessage(e, "Erro ao vincular"));
      return false;
    }
  };

  const unmap = async (productId) => {
    try { await unmapProduct(productId); toast.success("Vínculo removido"); reload(); } catch (e) { toast.error(errorMessage(e)); }
  };

  const syncAll = async () => {
    setBusy("sync");
    try {
      const r = await syncAvailability();
      toast.success(`${r.synced} itens sincronizados${r.errors ? `, ${r.errors} com erro` : ""}`);
    } catch (e) {
      toast.error(errorMessage(e, "Erro ao sincronizar disponibilidade"));
    } finally {
      setBusy("");
    }
  };

  return { ...state, loading, busy, reload, loadIfoodItems, map, unmap, syncAll };
}
